/**
 * Service Worker Registration
 * Handles registration and updates
 */

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  // Register service worker ONLY in production to avoid dev reload issues
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    const publicUrl = new URL(process.env.PUBLIC_URL || '', window.location.href);
    if (publicUrl.origin !== window.location.origin && publicUrl.origin !== '') {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.log('✅ Service worker is ready (localhost)');
        });
      } else {
        registerValidSW(swUrl, config);
      }
    });
  } else {
    // In development, proactively unregister any existing SW to prevent reload loops
    if (process.env.NODE_ENV !== 'production' && 'serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      });
      console.log('🧹 Development mode: service workers are disabled and unregistered.');
    } else {
      console.warn('⚠️ Service workers are not supported in this browser');
    }
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log('Service Worker registered:', registration);

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) {
          return;
        }

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              console.log('New content is available; please refresh.');

              if (config && config.onUpdate) {
                config.onUpdate(registration);
              }
            } else {
              console.log('Content is cached for offline use.');

              if (config && config.onSuccess) {
                config.onSuccess(registration);
              }
            }
          }
        };
      };

      // Register for background sync
      if ('sync' in registration) {
        registration.sync.register('sync-transactions').catch((err) => {
          console.log('Background sync registration failed:', err);
        });
      }

      // Register for periodic background sync (if supported)
      if ('periodicSync' in registration) {
        registration.periodicSync.register('periodic-sync', {
          minInterval: 15 * 60 * 1000, // 15 minutes
        }).catch((err) => {
          console.log('Periodic background sync registration failed:', err);
        });
      }
    })
    .catch((error) => {
      console.error('Error during service worker registration:', error);
    });

  // Listen for messages from service worker
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'SYNC_TRANSACTIONS') {
      console.log('Received sync request from service worker');
      // Trigger sync via offlineManager
      window.dispatchEvent(new CustomEvent('sw-sync-request'));
    }
  });
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          // Do not force a page reload; just unregister to avoid reload loops
          registration.unregister().then(() => {
            console.log('🧹 Unregistered invalid service worker (no reload)');
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error(error.message);
      });
  }
}
